package pl.decks.posthog.config

@Suppress("unused")
enum class Persistence(val jsValue: String) {
    COOKIE("cookie"),
    LOCAL_STORAGE("localStorage"),
    MEMORY("memory"),           // cookieless / GDPR friendly
}
